// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"361e95b5","206":"cebf309c","286":"a717df05","453":"d7318316","473":"8eb34b41","495":"713af131","515":"b169c30e","868":"edf38d83","888":"48159f5a"}[chunkId] + ".chunk.js";
};